import Room from './Room';

const VideoChat = ({ stacked, children, customStyle, parentVideoRef }) => {
  return <Room stacked={stacked} children={children} customStyle={customStyle} parentVideoRef={parentVideoRef} />;
};

export default VideoChat;
